import React from 'react'
import {
    ControlGroup,
    H3,
    Button,
    Intent,
    Alert,
    InputGroup,
} from "@blueprintjs/core";
import { CopyToClipboard } from "react-copy-to-clipboard";

var QRCode = require("qrcode.react");

const Access = ({ isOpen,
    onClose,
    onConfirm,
    cancelButtonText,
    confirmButtonText,
    intent,
    url,
    copiedToClipboard,
    title,
    handleCopy,
    text
}) => {
    return (
        <Alert
            isOpen={isOpen}
            onClose={onClose}
            cancelButtonText={cancelButtonText ? cancelButtonText : "Close"}
            confirmButtonText={confirmButtonText ? confirmButtonText : "Access"}
            icon="play"
            onConfirm={onConfirm}
            intent={intent ? intent : Intent.Primary}
        >
            <H3>Access session {title}</H3>
            {text}
            <div>
                <ControlGroup fill={true}>
                    <InputGroup
                        defaultValue={url}
                        disabled={true}
                    />
                    <CopyToClipboard
                        text={url}
                        onCopy={handleCopy}
                    >
                        <Button
                            intent={
                                copiedToClipboard ? Intent.SUCCESS : Intent.NONE
                            }
                            text={copiedToClipboard ? "Copied" : "Copy URL"}
                            rightIcon={
                                copiedToClipboard ? "tick" : "clipboard"
                            }
                        />
                    </CopyToClipboard>
                </ControlGroup>
                <QRCode
                value={url}
                size={300}
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                level={"L"}
                includeMargin={true}
                renderAs={"svg"}
                style={{ marginTop: 30 }}
              />
            </div>
            <br />
        </Alert>
    )
}

export default Access
